import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const CompositeVideo = ({ videoRef }) => {

  const { videoTrack } = useSelector((state) => state.compositeSettings);

  useEffect(() => {
    if (videoRef.current && videoTrack) {
      let subscriberStream = new MediaStream();
      subscriberStream.addTrack(videoTrack);
      videoRef.current.srcObject = subscriberStream;
      videoRef.current.play().catch(e => console.error("Subscriber video play error", e));
    }
  }, [videoRef, videoTrack]);

  return (
    <video ref={videoRef} id="subscriber-video" autoPlay playsInline muted style={{width:'100%', height:'100%', position:'absolute', top:0, left:0, objectFit:'contain'}}></video>
  );

}

export default CompositeVideo;